import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule } from "@angular/forms";
import { FeedbackService } from "../../services/feedback.service";
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import { environment } from "../../../environments/environment";

@Component({
	selector: "app-feedback",
	standalone: true,
	imports: [
		CommonModule,
		MatButtonModule,
		MatDialogModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		FormsModule,
		MatSnackBarModule,
	],
	templateUrl: "./feedback.component.html",
	styleUrls: ["./feedback.component.scss"],
})
export class FeedbackComponent {
	private dialog = inject(MatDialog);
	private feedbackService = inject(FeedbackService);
	private router = inject(Router);
	private snackBar = inject(MatSnackBar);

	showFeedbackButton = !environment.production;

	openFeedbackDialog(): void {
		const dialogRef = this.dialog.open(FeedbackDialogComponent, {
			width: "500px",
			data: {
				route: this.router.url,
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.submitFeedback(result);
			}
		});
	}

	private async submitFeedback(data: {
		description: string;
		type: "feedback" | "error";
	}): Promise<void> {
		try {
			await this.feedbackService.submitFeedback({
				description: data.description,
				type: data.type,
				route: this.router.url,
				status: "open",
				userId: "", // Will be set by service
				userEmail: "", // Will be set by service
			});
			this.snackBar.open("Thank you for your feedback!", "Close", { duration: 3000 });
		} catch (error) {
			this.snackBar.open("Error submitting feedback. Please try again.", "Close", {
				duration: 3000,
			});
		}
	}
}

@Component({
	selector: "app-feedback-dialog",
	standalone: true,
	imports: [
		CommonModule,
		MatDialogModule,
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		FormsModule,
	],
	templateUrl: "./feedback-dialog.component.html",
	styleUrls: ["./feedback-dialog.component.scss"],
})
export class FeedbackDialogComponent {
	description = "";
	type: "feedback" | "error" = "feedback";

	constructor(public dialogRef: MatDialogRef<FeedbackDialogComponent>) {}
}
